module.exports = __webpack_public_path__ + "3aab19a7.png";